<template>
    <footer class="w-full px-4 py-5 bg-base-200 flex flex-col gap-6 lg:gap-0 lg:grid lg:grid-cols-2">
        <div class="flex flex-col gap-2 justify-start w-full text-xs text-primary leading-1 underline order-2 lg:order-1">
            <LayoutServiceNavigation :navigation="serviceNavigation" link-style="text-xs underline hover:no-underline" />
        </div>
        <div class="flex flex-col gap-4 justify-start w-full text-xs text-primary leading-5 order-1 lg:order-2">
            <div class="flex flex-col gap-2">
                <p class="font-semibold">{{ $t('layout.footerNavigation.warrantyLabel') }}</p>
                <button
                    type="button"
                    class="block text-left underline hover:no-underline cursor-pointer"
                    @click="openWarrantyModal"
                >
                    {{ $t('layout.footerNavigation.warrantyLinkText') }}
                </button>
            </div>
            <p>
                <i18n-t
                    keypath="layout.footer.term"
                    tag="label"
                    for="layout.footer.tos"
                    scope="global"
                >
                    <a
                        href="https://policies.google.com/terms?hl=en"
                        target="_blank"
                        rel="noopener"
                        class="font-semibold underline hover:no-underline"
                    >
                        {{ $t('layout.footer.tos') }}
                    </a>
                    <a
                        href="https://policies.google.com/privacy?hl=en"
                        target="_blank"
                        rel="noopener"
                        class="font-semibold underline hover:no-underline"
                    >
                        {{ $t('layout.footer.dataprotection') }}
                    </a>
                </i18n-t>
            </p>
        </div>
        <p class="order-last text-xs text-primary lg:mt-6 lg:col-span-2">{{ $t('layout.footerLight.copyright', { 'year': new Date().getFullYear() }) }}</p>

        <LayoutFooterWarrantyModal modal-id="footer-light-warranty-modal" />
    </footer>
</template>

<script setup lang="ts">
import type { Schemas } from '#shopware'
defineProps<{
    serviceNavigation: NonNullable<Schemas['CmsElementA4gFooter']['config']>['bottomNavigation']['value']
}>()

function openWarrantyModal() {
    const modal = document.getElementById('footer-light-warranty-modal') as HTMLDialogElement
    modal?.showModal()
}
</script>
